// components/Boards/BoardSearchBar.jsx
import { Box, TextField, Button, useMediaQuery } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';

const BoardSearchBar = ({ searchQuery, setSearchQuery, onSearch }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
      <Box sx={{ display: 'flex', width: '100%', maxWidth: 600 }}>
        <TextField
          variant="outlined"
          placeholder="제목, 작성자"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {         // ⬅️ Enter 검색
              e.preventDefault();             // 폼 submit 방지
              onSearch();
            }
          }}
          sx={{ flexGrow: 1, mr: 1 }}
          size={isMobile ? 'small' : 'medium'}
        />
        <Button
          variant="contained"
          onClick={onSearch}
          startIcon={<SearchIcon />}
          size={isMobile ? 'small' : 'medium'}
          sx={{
            width: 100,
            height: isMobile ? 40 : 56,
            fontSize: isMobile ? '0.8rem' : '1rem',
          }}
        >
          검색
        </Button>
      </Box>
    </Box>
  );
};

export default BoardSearchBar;